const data = {
  title: "Floor 5-9",
  musicTrack: "MUSIC_BATTLE",
  story: "CIABATTA HAS HAD ENOUGH.",
  theme: "YELLOW",
  tilesWidth: 10,
  tilesHeight: 11,
  placements: [
    {
      type: "ENEMY_SPAWN",
      x: 5,
      y: 1,
      enemyType: "CIABATTA",
      spawnsBullets: true,
    },
    {
      type: "HERO_SPAWN",
      x: 3,
      y: 3,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 10,
      y: 1,
    },
    {
      type: "FIRE",
      x: 1,
      y: 2,
    },
    {
      type: "FIRE",
      x: 3,
      y: 2,
    },
    {
      type: "FIRE",
      x: 4,
      y: 2,
    },
    {
      type: "FIRE",
      x: 5,
      y: 2,
    },
    {
      type: "FIRE",
      x: 8,
      y: 2,
    },
    {
      type: "CONVEYOR",
      x: 2,
      y: 2,
      direction: "UP",
    },
    {
      type: "BULLET_DROPBOX",
      x: 2,
      y: 3,
    },
    {
      type: "FIRE",
      x: 9,
      y: 2,
    },
    {
      type: "CONVEYOR",
      x: 7,
      y: 2,
      direction: "UP",
    },
    {
      type: "BULLET_DROPBOX",
      x: 7,
      y: 3,
    },
    {
      type: "FIRE",
      x: 6,
      y: 2,
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 1,
      isRaised: true,
    },
    {
      type: "FIRE",
      x: 10,
      y: 2,
    },
    {
      type: "ICE",
      x: 3,
      y: 6,
    },
    {
      type: "ICE",
      x: 3,
      y: 5,
    },
    {
      type: "ICE",
      x: 4,
      y: 5,
    },
    {
      type: "ICE",
      x: 6,
      y: 5,
    },
    {
      type: "ICE",
      x: 5,
      y: 5,
    },
    {
      type: "ICE",
      x: 7,
      y: 5,
    },
    {
      type: "ICE",
      x: 8,
      y: 5,
    },
    {
      type: "ICE",
      x: 8,
      y: 6,
    },
    {
      type: "ICE",
      x: 7,
      y: 6,
    },
    {
      type: "ICE",
      x: 6,
      y: 6,
    },
    {
      type: "ICE",
      x: 5,
      y: 6,
    },
    {
      type: "ICE",
      x: 4,
      y: 6,
    },
    {
      type: "FIRE",
      x: 3,
      y: 9,
    },
    {
      type: "FIRE",
      x: 3,
      y: 8,
    },
    {
      type: "FIRE",
      x: 4,
      y: 8,
    },
    {
      type: "FIRE",
      x: 4,
      y: 9,
    },
    {
      type: "FIRE",
      x: 8,
      y: 8,
    },
    {
      type: "FIRE",
      x: 8,
      y: 9,
    },
    {
      type: "FIRE",
      x: 7,
      y: 9,
    },
    {
      type: "FIRE",
      x: 7,
      y: 8,
    },
    {
      type: "LOCK",
      x: 2,
      y: 10,
      color: "BLUE",
    },
    {
      type: "WALL",
      x: 1,
      y: 9,
    },
    {
      type: "WALL",
      x: 3,
      y: 11,
    },
    {
      type: "CHIP",
      x: 1,
      y: 11,
    },
    {
      type: "WALL",
      x: 10,
      y: 9,
    },
    {
      type: "WALL",
      x: 8,
      y: 11,
    },
    {
      type: "KEY",
      x: 1,
      y: 10,
      color: "GREEN",
    },
    {
      type: "LOCK",
      x: 9,
      y: 10,
      color: "GREEN",
    },
    {
      type: "CHIP",
      x: 10,
      y: 11,
    },
    {
      type: "KEY",
      x: 10,
      y: 4,
      color: "BLUE",
    },
  ],
};

export default data;
